// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

export const SUPABASE_URL = "https://zsbvxxdmhewaxkbkqgga.supabase.co";
export const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InpzYnZ4eGRtaGV3YXhrYmtxZ2dhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTIyMzUxMTQsImV4cCI6MjA2NzgxMTExNH0.bsT6FUdsPwwPjM1oa-_nZmNXf2-zaHJ8R5lJqBIU4nQ";
/** @deprecated Use SUPABASE_ANON_KEY instead */
const SUPABASE_PUBLISHABLE_KEY = SUPABASE_ANON_KEY;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});